export default "__VITE_ASSET__b3jtWO76__";